import { lazy } from 'react';
import ForumOutlined from '@mui/icons-material/ForumOutlined';
import type { FeatureManifest } from '../registry';
import { color } from '../../design/tokens';
import { createRetro, restoreRetro } from './api';
import type { NewSpaceAccessDto } from '../../../../shared/types/access';

const loadRetroPage = () => import('./RetroPage');
const RetroPage = lazy(loadRetroPage);

/** Retrospectives: columns of cards, votes, comments, action items and a facilitator timer. */
export const retrosFeature: FeatureManifest = {
    preload: loadRetroPage,
    type: 'retro',
    label: 'Retrospective',
    plural: 'Retrospectives',
    tagline: 'Cards, votes and a timer for quick retros.',
    Icon: ForumOutlined,
    accent: color.rose,
    pathPrefix: '/r',
    routes: [{ path: '/r/:shareId', element: <RetroPage />, handle: { immersive: true } }],
    create: async (title: string, access: NewSpaceAccessDto) => ({ shareId: (await createRetro(title, access)).shareId }),
    restore: shareId => restoreRetro(shareId),
};
